import { BrowserRouter, Routes, Route } from "react-router-dom";
import React,{ useEffect } from "react";
import { Toaster } from 'react-hot-toast';


// Billing
import PageBillingData from "./dashboard/billing/data/index"
import PageBillingPlan from "./dashboard/billing/plan/index"
import PagePaymentPlan from "./dashboard/billing/payment/index"
import PaymentSuccess from "./dashboard/billing/status/success/[index]";
import PaymentUnSuccess from "./dashboard/billing/status/unsuccess/[index]";

// Project
import PageProjects from "./dashboard/projects/index"
import PageProjectsAdd from "./dashboard/projects/add/index"
import PageProjectsEditView from "./dashboard/projects/edit/index"
import PageProjectsEditEditor from "./dashboard/projects/edit/editor/index"
import PageProjectEdit from "./dashboard/projects/edit-project/index"

import PagePreview from "./dashboard/projects/preview/index"
import PageProjectItemAdd from "./dashboard/projects/edit/add/index"



////order
import ShowOrder from "./dashboard/order/add/index";
import OrderPage from "./dashboard/order/index";
import AddOrders from "./dashboard/order/add/add";

///QrCode
import QrCodeOne from "./dashboard/qrCode/[index]";
import AllQr from "./dashboard/qrCode/showAll";
import EditQrcode from "./dashboard/qrCode/edit/[index]";
import EditVideo from "./dashboard/qrCode/edit/[editvideo]";
///index
import IndexPage from "./dashboard/index";
///user
import LoginPage from "./dashboard/user/login";
import DeActive from "./dashboard/user/deactive";
import RegisterPage from "./dashboard/user/register";
import Auth from "./dashboard/user/auth";
import LogOut from './component/dashboard/user/logout/logout';
import PrivacyPolicy from './dashboard/user/privacy-policy';
import Profile from './dashboard/user/profile';
import ChangePassword from './dashboard/user/chanche-password'
///camera
import Camera from './camera/index';
import Convert from './camera/test';
import QRcodeMaker from './camera/qrcode-maker';

////notfound
import NotFound from "./404";

// redux
import { ChangeLanguageItem } from "./redux/featuer/user/userSlice"
import { useSelector, useDispatch } from "react-redux";


import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

////import language 
import fa from './language/fa';
import en from './language/en';
import ar from './language/ar';
import Test from "./dashboard/test";
import ReChargesAccountPage from "./dashboard/billing/recharges";
import PayAccountPage from "./dashboard/billing/custom-payment";





function App() {
  var dispach = useDispatch()
  const { login, language } = useSelector((item) => item.user);

  useEffect(() => {

    var finLang = language;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const lang = params.get('lang') ?? "fa";

    if (lang) {
      finLang = lang;
      dispach(ChangeLanguageItem(lang))
    }

    const resources = {
      en: {
        translation: en
      },
      fa: {
        translation: fa
      },
      ar: {
        translation: ar
      },
    }
    i18n
      .use(initReactI18next)
      .init({
        resources,
        debug: true,
        lng: finLang,
        // lng: store.getState().user.language.toN,

        interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
        },
      });

  }, [])


  return (

    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={login ? <IndexPage /> : <LoginPage />}></Route>
        {/* Billing */}
        <Route exact path="/billing/data" element={<PageBillingData />}></Route>
        <Route exact path="/billing/plan" element={<PageBillingPlan />}></Route>
        <Route exact path="/billing/payment/:id" element={<PagePaymentPlan />}></Route>

        {/* Project */}
        <Route exact path="/projects" element={<PageProjects />}></Route>
        <Route exact path="/projects/add/:type" element={<PageProjectsAdd />}></Route>
        <Route exact path="/projects/edit/add/:type/:id" element={<PageProjectItemAdd />}></Route>
        <Route exact path="/projects/edit/:id" element={<PageProjectsEditView />}></Route>
        <Route exact path="/projects/edit/editor/:id/:row" element={<PageProjectsEditEditor />}></Route>
        <Route exact path="/projects/edit-project/:id" element={<PageProjectEdit />}></Route>
        <Route exact path="/projects/preview/:id" element={<PagePreview />}></Route>



        {/* ////order */}
        <Route exact path="/showOrder" element={<ShowOrder />}></Route>
        <Route exact path="/order" element={<OrderPage />}></Route>
        <Route exact path="/addOrder/:id" element={<AddOrders />}></Route>
        <Route exact path="/test" element={<Test />}></Route>
        <Route exact path="/qrcode-maker" element={<QRcodeMaker />}></Route>

        {/* ////ArQode */}
        <Route exact path="/qrcode/:id" element={<QrCodeOne />}></Route>
        <Route exact path="/allQr" element={<AllQr />}></Route>
        <Route exact path="/qrcode/edit/:id" element={<EditQrcode />}></Route>
        <Route exact path="/qrcode/editvideo/:id/:index" element={<EditVideo />}></Route>
        {/* //camera */}
        <Route path="/view/:username/:url" element={<Camera />}></Route>
        <Route path="/convert" element={<Convert />}></Route>

        {/* //user */}
        <Route exact path="/login" element={<LoginPage />}></Route>
        <Route exact path="/change-password/:id" element={<ChangePassword />}></Route>

        <Route exact path="/deactive" element={<DeActive />}></Route>
        <Route exact path="/LogOut" element={<LogOut />}></Route>
        <Route exact path="/register" element={<RegisterPage />}></Route>
        <Route exact path="/auth" element={<Auth isHeader={false} />}></Route>
        <Route exact path="/user/profile" element={<Profile />}></Route>
        <Route exact path="/privacy-policy" element={<PrivacyPolicy />}></Route>
        {/* ///not found */}
        <Route exact path="*" element={<NotFound />}></Route>
        {/* // payment */}
        {/* <Route exact path="/payment" element={<ViewPayment />}></Route> */}
        <Route exact path="/pay/increase" element={<ReChargesAccountPage />}></Route>
        <Route exact path="/pay" element={<PayAccountPage />}></Route>

        <Route exact path="/paymentSuccess/:id" element={<PaymentSuccess />}></Route>
        <Route exact path="/paymentUnSuccess/:id" element={<PaymentUnSuccess />}></Route>
      </Routes>

      <Toaster />

    </BrowserRouter>


  );
}



export default App;
